export enum SearchTabAlias {
    ACTIVITIES_SEARCH = "activitiesSearchTab",
    SERVICES_SEARCH = "servicesSearchTab",
    SCHOOLS_SEARCH = "schoolsSearchTab",
    EVENTS_SEARCH = "eventsCalendarSearchTab",
    CONTENT_SEARCH = "contentSearchTab"
}
